import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { User } from '../user.model';

@JsonObject('UsersResultsResponse')
export class UsersResultsResponse extends ApiResultsResponse<User> {

  @JsonProperty('results', [User])
  override results: User[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
